import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import type { Article } from '@/mocks/articles';

export default function LatestArticles() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setArticles(getLatestArticles());
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <section className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="animate-pulse space-y-6">
            <div className="h-8 w-48 bg-background-800 rounded"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3,4,5,6].map((i) => (
                <div key={i} className="h-80 bg-background-800 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  const featuredArticle = articles[0];
  const gridArticles = articles.slice(1, 7);

  return (
    <section className="w-full px-4 md:px-6 py-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-2xl font-bold text-foreground-100" style={{ fontFamily: "var(--font-heading)" }}>
              最新内幕
            </h2>
          </div>
          <Link to="/category/shehui-baoliao" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            {featuredArticle && (
              <ArticleCard article={featuredArticle} variant="featured" />
            )}
          </div>
          <div className="flex flex-col gap-3">
            {articles.slice(1, 5).map((article) => (
              <ArticleCard key={article.id} article={article} variant="compact" />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {gridArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}